export default __webpack_public_path__ + "static/media/bg1artweb.0711a651.jpg";